import React from "react";
import "../css/about.scss";
import { SITE_CONFIG } from "../config/siteConfig";

function About() {
  return (
    <div className="about">
      <div className="page-width page-width--narrow section-template--18562781773881__main-padding">
        <h1 className="main-page-title page-title h0">Who We Are</h1>
        <div className="rte">
          <p>
            {SITE_CONFIG.brand} is a {SITE_CONFIG.operatingRegion}-based online edit of useful home objects, tableware, small accessories, confectionery and bottled drinks. The assortment favours clear material information, compact forms and pieces that can move between ordinary routines and gifting.
          </p>
          <p>
            We photograph each product as its own object and write the catalogue around its actual use: dimensions, finish, care, expected variation and material-specific cautions. Hand-finished ceramic, glass, wood, cotton and paper are allowed to look like themselves rather than perfectly uniform surfaces.
          </p>
          <p>
            The shop operates from {SITE_CONFIG.operatingRegion} and displays prices in {SITE_CONFIG.currency}. Customer care is handled by email at <a href={`mailto:${SITE_CONFIG.supportEmail}`}>{SITE_CONFIG.supportEmail}</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
